import { Navigate, Outlet } from "react-router-dom";

const useAuth = () => {
    const user = { loggedIn: localStorage.getItem("token") !== null ? true : false }
    return user && user.loggedIn
}
const ProtectedRoute = () => {
    const isAuth = useAuth();
    return isAuth ? <Outlet /> : <Navigate to='/login' />
}

export default ProtectedRoute;